import apiClient from './apiClient';
import {
  ESentralFirma,
  ESentralSysInfo,
  ESentralDBTilkobling,
  ESentralKommInfo,
  CreateESentralFirmaRequest,
  CreateESentralFirmaResult,
  FirmaConfigurationSummary,
} from '../types/ESentral';

const api = apiClient;

export const esentralApi = {
  // Hent alle firma
  getAllFirma: async (): Promise<ESentralFirma[]> => {
    const response = await api.get<ESentralFirma[]>('/api/esentral/firma');
    return response.data;
  },

  // Hent et spesifikt firma
  getFirma: async (firmaNr: string): Promise<ESentralFirma> => {
    const response = await api.get<ESentralFirma>(`/api/esentral/firma/${firmaNr}`);
    return response.data;
  },

  // Hent neste ledige firmanummer
  getNextAvailableFirmaNr: async (): Promise<string> => {
    const response = await api.get<{ firmaNr: string }>('/api/esentral/firma/next-available');
    return response.data.firmaNr;
  },

  // Opprett nytt firma
  createFirma: async (request: CreateESentralFirmaRequest): Promise<CreateESentralFirmaResult> => {
    const response = await api.post<CreateESentralFirmaResult>('/api/esentral/firma', request);
    return response.data;
  },

  // Opprett firma for en tenant og koble dem sammen
  createFirmaForTenant: async (
    tenantId: number,
    request: CreateESentralFirmaRequest
  ): Promise<CreateESentralFirmaResult> => {
    const response = await api.post<CreateESentralFirmaResult>(
      `/api/esentral/firma/for-tenant/${tenantId}`,
      request
    );
    return response.data;
  },

  // Hent SysInfo for firma
  getSysInfo: async (firmaNr: string): Promise<ESentralSysInfo> => {
    const response = await api.get<ESentralSysInfo>(`/api/esentral/firma/${firmaNr}/sysinfo`);
    return response.data;
  },

  // Oppdater SysInfo
  updateSysInfo: async (firmaNr: string, sysInfo: ESentralSysInfo): Promise<void> => {
    await api.put(`/api/esentral/firma/${firmaNr}/sysinfo`, sysInfo);
  },

  // Hent DBTilkoblinger
  getDBTilkoblinger: async (firmaNr: string): Promise<ESentralDBTilkobling[]> => {
    const response = await api.get<ESentralDBTilkobling[]>(`/api/esentral/firma/${firmaNr}/dbtilkobling`);
    return response.data;
  },

  // Hent KommInfo
  getKommInfo: async (firmaNr: string): Promise<ESentralKommInfo[]> => {
    const response = await api.get<ESentralKommInfo[]>(`/api/esentral/firma/${firmaNr}/komminfo`);
    return response.data;
  },

  // Hent konfigurasjonsoversikt for et firma
  getFirmaConfiguration: async (firmaNr: string): Promise<FirmaConfigurationSummary> => {
    const response = await api.get<FirmaConfigurationSummary>(`/api/esentral/firma/${firmaNr}/configuration`);
    return response.data;
  },

  // Hent konfigurasjonsoversikt for tenantens firma, med avvik mot tenanten
  getTenantConfiguration: async (tenantId: number): Promise<FirmaConfigurationSummary> => {
    const response = await api.get<FirmaConfigurationSummary>(`/api/esentral/tenant/${tenantId}/configuration`);
    return response.data;
  },
};

export default esentralApi;
